import { useAtom } from "jotai";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import Price from "@/app/components/lib/Price";
import { isSignedInAtom } from "@/hooks/authAtoms";
import { useTranslation } from "@/hooks/localization/useTranslations";
import useSellingMode from "@/hooks/useSellingMode";
import { useTaxSettings } from "@/hooks/useTaxSettings";
import { Col, Row, DropdownItem } from "@/utils/bootstrap";
import { PagesPaths } from "@/utils/functions/pages-paths";

interface Props {
  total: number;
  tax: number | undefined;
}

const CartMenuBtns: React.FC<Props> = ({ total, tax }) => {
  const t = useTranslation();
  const taxSettings = useTaxSettings();
  const router = useRouter();

  const [isSignedIn] = useAtom(isSignedInAtom);
  const { enableCheckout } = useSellingMode();
  const checkoutPath = isSignedIn
    ? PagesPaths.userCheckout
    : PagesPaths.checkout;
  return (
    <div className="cart-menu-btns w-100">
      {taxSettings.enabled && !!tax && (
        <Row className="m-0 justify-content-between align-items-center">
          <Col className="total-title">
            <Row className="m-0">{t[taxSettings.labelKey]}</Row>
          </Col>
          <Col className="col-auto">
            <Price price={{ value: tax }} />
          </Col>
        </Row>
      )}

      <Row className="m-0 justify-content-between align-items-center">
        <Col className="total-title">
          <Row className="m-0">{t.grand_total}</Row>
        </Col>
        <Col className="col-auto">
          <Price price={{ value: total, className: "total" }} />
        </Col>
      </Row>
      <DropdownItem>
        <CustomButton
          type={BtnTypes.secondary}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          onClick={() => router.push(PagesPaths.cart)}
          fullWidth
        >
          {t.go_to_cart_page}
        </CustomButton>
      </DropdownItem>
      <DropdownItem>
        {enableCheckout && (
          <CustomButton
            type={BtnTypes.primary}
            size={BtnSizes.large}
            radius={BtnRadius.small}
            onClick={() => router.push(checkoutPath)}
            fullWidth
          >
            {t.checkout}
          </CustomButton>
        )}
      </DropdownItem>
    </div>
  );
};

export default CartMenuBtns;
